import { useAtom } from "jotai";
import React from "react";
import daycare from "../../../assets/social-care.png";

import { activeChildDetail, alertModal } from "../../../AtomStore/store";
import { useRequestProcessor } from "../../../requestProcessor";
import {
  cancelPauseRequest,
  cancelRequest,
} from "../../../QueryFunctions/queryfunction";
import moment from "moment";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";

import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { StyledButtonOne } from "./styles";
import { useNavigate } from "react-router-dom";

const PastRequestItem = ({ item, index, md, refetch }) => {
  const navigate = useNavigate();
  const icons = {
    "Center Shift": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fillRule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    Leaves: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path d="M12 11.993a.75.75 0 0 0-.75.75v.006c0 .414.336.75.75.75h.006a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75H12ZM12 16.494a.75.75 0 0 0-.75.75v.005c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H12ZM8.999 17.244a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.006ZM7.499 16.494a.75.75 0 0 0-.75.75v.005c0 .414.336.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H7.5ZM13.499 14.997a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.005a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.005ZM14.25 16.494a.75.75 0 0 0-.75.75v.006c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75h-.005ZM15.75 14.995a.75.75 0 0 1 .75-.75h.005a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1-.75-.75v-.006ZM13.498 12.743a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75ZM6.748 14.993a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" />
        <path
          fillRule="evenodd"
          d="M18 2.993a.75.75 0 0 0-1.5 0v1.5h-9V2.994a.75.75 0 1 0-1.5 0v1.497h-.752a3 3 0 0 0-3 3v11.252a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.492a3 3 0 0 0-3-3H18V2.993ZM3.748 18.743v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    "Child Pause": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path d="M12 11.993a.75.75 0 0 0-.75.75v.006c0 .414.336.75.75.75h.006a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75H12ZM12 16.494a.75.75 0 0 0-.75.75v.005c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H12ZM8.999 17.244a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.006ZM7.499 16.494a.75.75 0 0 0-.75.75v.005c0 .414.336.75.75.75h.005a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.75H7.5ZM13.499 14.997a.75.75 0 0 1 .75-.75h.006a.75.75 0 0 1 .75.75v.005a.75.75 0 0 1-.75.75h-.006a.75.75 0 0 1-.75-.75v-.005ZM14.25 16.494a.75.75 0 0 0-.75.75v.006c0 .414.335.75.75.75h.005a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0-.75-.75h-.005ZM15.75 14.995a.75.75 0 0 1 .75-.75h.005a.75.75 0 0 1 .75.75v.006a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1-.75-.75v-.006ZM13.498 12.743a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75ZM6.748 14.993a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" />
        <path
          fillRule="evenodd"
          d="M18 2.993a.75.75 0 0 0-1.5 0v1.5h-9V2.994a.75.75 0 1 0-1.5 0v1.497h-.752a3 3 0 0 0-3 3v11.252a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.492a3 3 0 0 0-3-3H18V2.993ZM3.748 18.743v-7.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    "Add Two Way Transport": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 48 48"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="black"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.54 39.08h7.74v4.42H8.54zm23.18 0h7.74v4.42h-7.74zM7.29 11h1.2v7.94a2.44 2.44 0 0 1-2.4-2.47v-4.25A1.22 1.22 0 0 1 7.29 11m33.42 0h-1.2v7.94a2.44 2.44 0 0 0 2.4-2.47v-4.25a1.22 1.22 0 0 0-1.2-1.22M24 4.5c-5.51 0-15.46.86-15.46 3.1v31.48h30.92V7.6c0-2.24-10.02-3.1-15.46-3.1m0 4.23q8.19 0 12.2 1.23a1 1 0 0 1 .67.92v17a1 1 0 0 1-1 1H12.14a1 1 0 0 1-1-1v-17a1 1 0 0 1 .67-.92q4-1.23 12.19-1.23M13.59 31.5a2.5 2.5 0 0 1 0 5h0a2.47 2.47 0 0 1-2.43-2.5h0a2.47 2.47 0 0 1 2.43-2.5m20.87 0a2.5 2.5 0 0 1 0 5h0A2.47 2.47 0 0 1 32 34h0a2.47 2.47 0 0 1 2.46-2.5"
        />
      </svg>
    ),
    "Delete One Way Transport": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 48 48"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="black"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.54 39.08h7.74v4.42H8.54zm23.18 0h7.74v4.42h-7.74zM7.29 11h1.2v7.94a2.44 2.44 0 0 1-2.4-2.47v-4.25A1.22 1.22 0 0 1 7.29 11m33.42 0h-1.2v7.94a2.44 2.44 0 0 0 2.4-2.47v-4.25a1.22 1.22 0 0 0-1.2-1.22M24 4.5c-5.51 0-15.46.86-15.46 3.1v31.48h30.92V7.6c0-2.24-10.02-3.1-15.46-3.1m0 4.23q8.19 0 12.2 1.23a1 1 0 0 1 .67.92v17a1 1 0 0 1-1 1H12.14a1 1 0 0 1-1-1v-17a1 1 0 0 1 .67-.92q4-1.23 12.19-1.23M13.59 31.5a2.5 2.5 0 0 1 0 5h0a2.47 2.47 0 0 1-2.43-2.5h0a2.47 2.47 0 0 1 2.43-2.5m20.87 0a2.5 2.5 0 0 1 0 5h0A2.47 2.47 0 0 1 32 34h0a2.47 2.47 0 0 1 2.46-2.5"
        />
      </svg>
    ),
    "Add One Way Transport": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 48 48"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="black"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.54 39.08h7.74v4.42H8.54zm23.18 0h7.74v4.42h-7.74zM7.29 11h1.2v7.94a2.44 2.44 0 0 1-2.4-2.47v-4.25A1.22 1.22 0 0 1 7.29 11m33.42 0h-1.2v7.94a2.44 2.44 0 0 0 2.4-2.47v-4.25a1.22 1.22 0 0 0-1.2-1.22M24 4.5c-5.51 0-15.46.86-15.46 3.1v31.48h30.92V7.6c0-2.24-10.02-3.1-15.46-3.1m0 4.23q8.19 0 12.2 1.23a1 1 0 0 1 .67.92v17a1 1 0 0 1-1 1H12.14a1 1 0 0 1-1-1v-17a1 1 0 0 1 .67-.92q4-1.23 12.19-1.23M13.59 31.5a2.5 2.5 0 0 1 0 5h0a2.47 2.47 0 0 1-2.43-2.5h0a2.47 2.47 0 0 1 2.43-2.5m20.87 0a2.5 2.5 0 0 1 0 5h0A2.47 2.47 0 0 1 32 34h0a2.47 2.47 0 0 1 2.46-2.5"
        />
      </svg>
    ),
    "Delete Two Way Transport": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 48 48"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="black"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.54 39.08h7.74v4.42H8.54zm23.18 0h7.74v4.42h-7.74zM7.29 11h1.2v7.94a2.44 2.44 0 0 1-2.4-2.47v-4.25A1.22 1.22 0 0 1 7.29 11m33.42 0h-1.2v7.94a2.44 2.44 0 0 0 2.4-2.47v-4.25a1.22 1.22 0 0 0-1.2-1.22M24 4.5c-5.51 0-15.46.86-15.46 3.1v31.48h30.92V7.6c0-2.24-10.02-3.1-15.46-3.1m0 4.23q8.19 0 12.2 1.23a1 1 0 0 1 .67.92v17a1 1 0 0 1-1 1H12.14a1 1 0 0 1-1-1v-17a1 1 0 0 1 .67-.92q4-1.23 12.19-1.23M13.59 31.5a2.5 2.5 0 0 1 0 5h0a2.47 2.47 0 0 1-2.43-2.5h0a2.47 2.47 0 0 1 2.43-2.5m20.87 0a2.5 2.5 0 0 1 0 5h0A2.47 2.47 0 0 1 32 34h0a2.47 2.47 0 0 1 2.46-2.5"
        />
      </svg>
    ),
    "Program Change": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 32 32"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="black"
          d="M24 30H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16.618l-5-2.5l-5 2.5V4H8v24h16v-4h2v4a2.003 2.003 0 0 1-2 2m-3-14.118l3 1.5V4h-6v13.382Z"
        />
      </svg>
    ),
    "Not Satisfied Refund": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="currentColor"
          d="M5.676 4.257c3.928-3.219 9.733-2.995 13.4.672c3.905 3.905 3.905 10.237 0 14.142s-10.237 3.905-14.142 0a9.99 9.99 0 0 1-2.678-9.304l.077-.313l1.934.51a8 8 0 1 0 3.053-4.45l-.22.166l1.017 1.017l-4.596 1.06l1.06-4.596zM13.005 6v2h2.5v2h-5.5a.5.5 0 0 0-.09.992l.09.008h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2h5.5a.5.5 0 0 0 .09-.992l-.09-.008h-4a2.5 2.5 0 1 1 0-5h1V6z"
        />
      </svg>
    ),
    "Child Attrition": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 256 256"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path
          fill="currentColor"
          d="M128 56h-16V16a8 8 0 0 1 16 0Zm64 67.62V72a16 16 0 0 0-16-16h-48v60.69l18.34-18.35a8 8 0 0 1 11.32 11.32l-32 32a8 8 0 0 1-11.32 0l-32-32a8 8 0 0 1 11.32-11.32L112 116.69V56H64a16 16 0 0 0-16 16v128a8 8 0 0 0 8 8h74.7c.32.67.67 1.34 1.05 2l.24.38l22.26 34a8 8 0 0 0 13.39-8.76l-22.13-33.79A12 12 0 0 1 166.4 190c.07.13.15.26.23.38l10.68 16.31a8 8 0 0 0 14.69-4.38V144a74.84 74.84 0 0 1 24 54.69V240a8 8 0 0 0 16 0v-41.35a90.89 90.89 0 0 0-40-75.03"
        />
      </svg>
    ),
    "Child Resume": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      >
        <path fill="currentColor" d="M6 18V6h2v12zm4 0l10-6l-10-6z" />
      </svg>
    ),
    "Extended Daycare": (
      <img
        src={daycare}
        alt="daycare logo"
        className="size-14 bg-[#d9d9d9] text-dark rounded-lg p-2"
      ></img>
    ),
  };

  const [modal, setModal] = useAtom(alertModal);
  const [activeChild] = useAtom(activeChildDetail);

  const { useMutationWrapper } = useRequestProcessor();

  const CancelPause = useMutationWrapper(
    "CancelPause",
    (item, refetch) => {
      console.log(
        "[Past Request Item] Calling API: /admission/cancelChildPauseRequest",
        {
          child_id: activeChild?.id,
          request_id: item.request_id,
        }
      );

      return cancelPauseRequest(item.request_id);
    },
    {
      onSuccess: (data) => {
        console.log("[Past Request Item] Cancel Pause Request response:", data);
        refetch();
      },
    }
  );

  const CancelRequest = useMutationWrapper(
    "CancelRequest",
    (item, refetch) => {
      console.log(
        "[Past Request Item] Calling API: /financials/cancelCustomerRequest",
        {
          child_id: activeChild?.id,
          request_id: item.request_id,
        }
      );
      return cancelRequest(item.request_id);
    },
    {
      onSuccess: (data) => {
        console.log("[Past Request Item] Cancel  Request response:", data);
        refetch();
      },
    }
  );

  const onCancelPress = (item) => {
    setModal({
      ...modal,
      state: true,
      type: "Success",
      isConfirm: true,
      message: "Are You Sure You Want To Cancel This Request ?",
      onOkPressed: () => {
        console.log("item type", item.type);
        if (item.type === "Leaves" || item.type === "Child Pause") {
          CancelPause.mutate(item, refetch);
        } else {
          CancelRequest.mutate(item, refetch);
        }
      },
    });

    refetch();
  };
  return (
    <li className="grid grid-cols-12 gap-1 mb-2 bg-white p-2 rounded-lg">
      {CancelRequest.isLoading || CancelPause.isLoading ? (
        <SpinnerLoading />
      ) : (
        ""
      )}
      <div className={`flex ${item.showCancel ? "col-span-7" : "col-span-9"}`}>
        <div className=" p-1 rounded-lg flex items-center ">
          {icons[item.type]}
        </div>
        <div className="ml-1 flex justify-center flex-col">
          <h3 className="text-dark text-md font-bold lg:text-md">
            {item.type}
          </h3>
          {/* <h3 className='text-xs '>Requested On July,18 2024</h3> */}
          <h3 className="text-xs">
            Affected On{" "}
            {item.type === "Center Shift"
              ? moment(item.end_date, "YYYY-MM-DD").isValid()
                ? moment(item.end_date, "YYYY-MM-DD").format(DEFAULT_FORMAT)
                : ""
              : moment(item.date, "YYYY-MM-DD").isValid()
              ? moment(item.date, "YYYY-MM-DD").format(DEFAULT_FORMAT)
              : ""}
          </h3>
        </div>
      </div>
      <div className="col-span-3 flex items-end justify-center flex-col">
        <h3 className="text-sm font-medium text-center text-dark">
          {moment(item.request_date, "YYYY-MM-DD HH:mm:ss").format(
            DEFAULT_FORMAT
          )}
        </h3>
        <h3
          className={`text-md font-bold text-center md:text-sm ${
            item?.status === "Cancelled" ? "text-red-500" : "text-green-500"
          }`}
        >
          {" "}
          {item.status}
        </h3>
      </div>
      {item.showCancel && (
        <button
          className=" col-span-2 flex items-center justify-center"
          onClick={() => onCancelPress(item)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-10 text-white fill-red-500"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </button>
      )}
      {/* <div className="d-flex"> */}
      <div className="col-span-12 flex justify-between items-center">
        {item.showEarlyPauseAndResume && (
          <StyledButtonOne
            onClick={() => {
              navigate("/earlyResume", { state: item });
            }}
          >
            Early Resume
          </StyledButtonOne>
        )}
        {item.showEarlyPauseAndResume && (
          <button
            className="btn btn-warning p-2"
            type="button"
            style={{ marginTop: "4px" }}
            onClick={() => {
              navigate("/extendPause", { state: item });
            }}
          >
            Extend Pause
          </button>
        )}

        {/* {item.showCancel && (
          <StyledButtonTwo onClick={() => onCancelPress(item)}>
            Cancel
          </StyledButtonTwo>
        )} */}
      </div>
    </li>
  );
};

export default PastRequestItem;
